/* eslint-disable i18next/no-literal-string -- TanStack cache key segments */
/**
 * `entities/approval-chain` TanStack Query key factory.
 *
 * Keys are namespaced under `['project', projectId, 'approval-chains', ...]` so that
 * a single broad invalidation (`['project', projectId, 'approval-chains']`) from a
 * mutation refreshes every approval-chain query for the project (list + details).
 */

export const APPROVAL_CHAIN_QUERY_KEYS = {
  /**
   * Root key for every approval-chain query under a project. Mutations invalidate
   * with this to refresh the list + all details in one call; it is also the
   * single source of truth for the `'approval-chains'` namespace segment.
   */
  all: (projectId: string) => ['project', projectId, 'approval-chains'] as const,

  /** Paginated approval-chain list under a project. */
  list: (projectId: string) => ['project', projectId, 'approval-chains', 'list'] as const,

  /**
   * The roles a step in this project may name. Outside the `'approval-chains'` root: saving a
   * chain does not change which roles exist.
   */
  stepRoles: (projectId: string) => ['project', projectId, 'approval-step-roles'] as const,

  /** Single approval chain by id. */
  detail: (projectId: string, approvalChainId: string) =>
    ['project', projectId, 'approval-chains', 'detail', approvalChainId] as const,
} as const;
